import { IModule, IModuleBuilder } from "app/IModule";
import React from "react";

export default class DisclaimerModule implements IModule {

    constructor(private disclaimerUrl: string) {}

    build(builder: IModuleBuilder) {
        builder.addRoute(this.disclaimerUrl, React.lazy(() => import("./Disclaimer.page")), true);
    }
}